import { doFetch } from "../../lib/doFetch";

export const postPreferences = async (preferences) => {
  try {
    const body = JSON.stringify({ preferences: preferences });
    return await doFetch("/research/japi/user/preferences", body, "POST");
  } catch (err) {
    console.error("Failed to save preferences", err); // no GUI response required.
  }
};
